module.exports = __webpack_public_path__ + "img/facebook-messenger.d67f3795.png";